<template>
	<div class="hideScroll">
	<div class="investingbounds" ref="investingbounds">
		<div class="investing" ref="investingcontent">
			<!-- <div class="scroll" ref="scrollaaa">
			<div class="viewBounds"> -->

			<div class="center" style="background-color: #000; width: 10px; height: 10px;">
				<div class="item" v-for="(item,index) in viewlist" :style="{'left':item.left+'rem',
						top:item.top+'rem',
						width:(itemSize)+'rem',
						'backgroundColor':'rgba(189,142,117,'+((10-item.opt*3)/10)+')',
						'lineHeight':(itemSize)+'rem',
						height:(itemSize)+'rem'}">
					<a target="_blank" v-if="index<19" :href="item.siteLink">{{item.siteName}}</a>
					<a target="_blank" class="more" v-if="index==19" href="/links">查看更多&gt;&gt;</a>
				</div>
				<div class="cont">
					<div>
						<h4>{{detail.subsidiaryTitle}}</h4>
						<span>{{detail.subsidiarySubTitle}}</span>
					</div>
				</div>
				<!-- <div :style="'width:'+viewWidth+'rem;margin-left:-'+viewWidth/2+'rem'" style="position: relative; height: 10px; background-color: #f00;"></div> -->
				<!-- </div>
			</div> -->
			</div>
		</div>
	</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				index: 0,
				colors: [],
				investings: [],
				zoom: 1,
				ytotal: 5,
				ww: 0,
				datalist: []
			}
		},
		props: {
			detail: {
				type: Object,
				default: ()=>{
					return {};
				}
			}
		},
		watch: {
			datalist() {
				let a = this.$refs.scrollaaa
				if (a) {
					a.scrollLeft = this.viewWidth
				}
			}
		},
		computed: {
			itemSize() {
				return this.ww < 750 ? 7 : 10
			},
			viewWidth() {
				return (Math.ceil(this.datalist.length / this.ytotal) + 3.2) * Math.SQRT2 * this.itemSize
			},
			viewlist() {
				let count = 40;


				let ytotal = this.ytotal
				var arr = []

				var index = 0;

				for (var i = 0; i < Math.ceil(count / ytotal / 2); i++) { //y 
					let top = -1 * ytotal * this.itemSize / 1.67
					let max = Math.ceil(ytotal / 2)
					let leftmax = max * this.itemSize / 2

					for (var a = 0; a < ytotal; a++) { //x 
						var yindex = a
						if (a >= max) {
							yindex = ytotal - a - 1
						}

						var left = this.itemSize / 1.2 * yindex + i * this.itemSize * 1.68 + this.itemSize * Math.SQRT2
						top += this.itemSize / 1.2
						var item = this.itemText(index)
						arr.push({
							...item,
							...{
								top: top,
								left: -1 * left,
								opt: i
							}
						})
						index += 1
					}

					top = -1 * ytotal * this.itemSize / 1.67

					for (var a = 0; a < ytotal; a++) { //x 
						var yindex = a
						if (a >= max) {
							yindex = ytotal - a - 1
						}
						var left = this.itemSize / 1.2 * yindex + i * this.itemSize * 1.68 + this.itemSize * Math.SQRT2 / 3
						top += this.itemSize / 1.2
						var item = this.itemText(index)
						arr.push({
							...item,
							...{
								top: top,
								left: left,
								opt: i
							}
						})
						index += 1
					}

				}

				return arr
			}
		},
		created() {
			this.get(`siteFriendSiteLink/list/1`, {}, res => {
				this.datalist = res.data
			})
			this.ww = window.innerWidth
		},
		mounted() {
			window.onresize = () => {
				this.ww = window.innerWidth 
				let bounds = this.$refs.investingbounds.offsetWidth
				let content = this.$refs.investingcontent.offsetWidth
				if (content > bounds) {
					this.$refs.investingbounds.scrollLeft = (content - bounds) / 2
				}
			}
		},
		methods: {
			itemText(index) {
				if (this.datalist.length > index) {
					return this.datalist[index]
				}
				return {}
			}
		}
	}
</script>

<style scoped>
	.investing {
		background-color: #F9F9F9;
		position: relative;
		height: 55rem;
		width: 100%;
		overflow: hidden;
	}

	.investing .viewBounds {
		position: relative;
		height: 100%;
		overflow: hidden;
	}

	.investing .scroll {
		position: relative;
		overflow: hidden;
		height: 106%;
	}

	.investing .center {
		position: absolute;
		top: 47%;
		left: 50%;
	}

	.cont {
		position: absolute;
		z-index: 1000;
		width: 22rem;
		height: 22rem;
		overflow: hidden;
		margin-left: -10.7rem;
		margin-top: -10.7rem;
		transform: rotateZ(45deg);
		background-color: #BD8E75;
	}

	.cont div {
		position: absolute;
		background-color: #f4efed;
		left: 0;
		top: 0;
		width: 160%;
		z-index: 100;
		height: 130%;
		margin-top: -15%;
		margin-left: -30%;
		transform: rotateZ(-45deg);
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		font-size: 1.2rem;
		text-transform: uppercase;
	}

	/* .cont::after{
		position: absolute;
		transform: rotateZ(-45deg);  
		content: '';
		width: 5rem;
		height: 5rem;
		background-color: #BD8E75;
		margin-top: -3rem;
		margin-left: -3rem;
	}
	.cont::before{ 
		position: absolute;
		transform: rotateZ(-45deg);  
		content: '';
		width: 5rem;
		height: 5rem;
		background-color: #BD8E75;
		right: -3rem;
		bottom: -3rem;
	} */
	.cont h4 {
		font-weight: bold;
		font-size: 2.5rem;
		line-height: 5rem;
	}

	.investing .center .item {
		position: absolute;
		transform: translate3d(0, 0, 0) rotateZ(45deg) scale(1, 1);
		animation: 4s;
		display: flex;
		justify-content: center;
		will-change: transform;
		box-shadow: #999 0 0 0px;
		align-items: center;
	}

	.investing .center .item:hover {
		transform: translate3d(0, 0, 0) rotateZ(45deg) scale(1.12, 1.12);
		box-shadow: #999 0 0 8px;
		transition-duration: 0.3s;
	}

	.investing .center .item a.more {
		line-height: 3.7rem;
	}

	.investing .center .item a {
		display: block;
		padding: .4rem;
		height: 3.7rem;
		line-height: 1.8rem;
		z-index: 10000;
		position: relative;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		font-size: 1.2rem;
		box-sizing: border-box;
		text-align: center;
		color: #fff;
		transform: rotateZ(-45deg);
	}




	@media screen and (max-width: 750px) {
		.hideScroll{
			width: 100%;
			height: 40rem;
			overflow: hidden;
		}
		.investingbounds {
			overflow-x: scroll;
			overflow-y: hidden;
			width: 100%;
			height: 42rem;
		}

		.investing {
			height: 40rem;
			width: 72rem;
		}

		.investing .cont {
			width: 16rem;
			height: 16rem;
			overflow: hidden;
			margin-left: -7.7rem;
			margin-top: -7.9rem;
		}

		.center .cont h4 {
			font-size: 2rem;
			line-height: 4rem;
		}

		.investing .center .item a {
			font-size: 1rem;
		}

		.center .cont div {
			font-size: 1rem;
		}
	}
</style>